<template>
	<div class="row absolute">
		<div class="col-sm-10">
			<div>
				<div class="row">
					<div class="col-sm-7">
						<label class="admin-text" for="prod-search">Nombre del producto</label><br>
						<input id="prod-search" class="admin-input" type="text" placeholder="Agrega el nombre del producto" v-model="form.name">
					</div>
					<div class="col-sm-2">
						<p class="admin-text">Color 1</p>
						<input type="text" class="form-control" placeholder="#ff0000" v-model="form.color"/>
						<!-- <div class="admin-background-second padding-sm">
							<div class="admin-span-color"></div>
							<span class="admin-text-sm text-uppercase">#ff0000</span>
						</div> -->
					</div>
					<div class="col-sm-2">
						<p class="admin-text">Color 2</p>
						<input type="text" class="form-control" placeholder="#ff0000" v-model="form.color2"/>
						<!-- <div class="admin-background-second padding-sm">
							<div class="admin-span-color"></div>
							<span class="admin-text-sm text-uppercase">#ff0000</span>
						</div> -->
					</div>
				</div>
				<div class="row">
					<div class="col-sm-7">
						<label class="admin-text" for="prod-search">Código SKU</label><br>
						<input id="prod-search" class="admin-input" type="text" placeholder="Agrega el nombre del producto" v-model="form.sku">
					</div>
					<div class="col-sm-3">
						<div class="custom-checkbox-gray" style="margin-top: 30px;">
					        <input type="checkbox" id="cb1" v-model="form.is_for_home">
					        <label for="cb1">Producto en el Home</label>
				      	</div>
			      	</div>
				</div>
				<div class="row">
					<div class="col-sm-6">
						<div class="padding-top-sm">
							<p class="admin-text pull-left">Imágenes de producto:</p>
							<span class="admin-text"><strong>400 x 400px</strong></span>
						</div>
					</div>
					<div class="col-sm-offset-3 col-sm-3">
						<label class="btn btn-black btn-lg btn-file pull-right">
						    Subir imágenes <input type="file" style="display: none;" @change="appendImg">
						</label>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12">
						<div class="wrapper" v-for="image in render_images" id="{{ $index }}" v-drag-and-drop drop="handleDrop">
							<i class="fa fa-bars pull-left" aria-hidden="true"></i>
							<p class="admin-text admin-text-sm pull-left">{{ image.file_name }}</p>
							<a class="admin-text admin-text-sm pull-right" @click="handleRemove(image, $index)"><u> Eliminar</u></a>
						</div>
					</div>

					<div class="col-sm-6" v-if="!render_images.length">Selecciona imagenes del producto.</div>
				</div>

				<div class="row">
					<div class="col-sm-6">
						<label class="admin-text" for="prod-search">Categoría</label>
						<br>
						<select class="admin-input" v-model="form.category_id" @change="subcategories">
							<option value="" disabled>Categoría</option>
							<option v-for="category in categories" :value="category.id">{{ category.name }}</option>
						</select>
					</div>

					<div class="col-sm-6">
						<label class="admin-text" for="prod-search">Subcategoría</label><br>
						<select class="admin-input" v-model="form.subcategory_id">
							<option value="" disabled>Subcategoria</option>
							<option v-for="subcategory in subcategories_list" :value="subcategory.id">{{ subcategory.name }}</option>
						</select>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
						<label class="admin-text" for="prod-search">Precio</label>
						<br>
						<input type="text" class="admin-input" placeholder="$" v-model="form.original_price">
					</div>
					<div class="col-sm-4">
						<label class="admin-text" for="prod-search">Descuento</label>
						<br>
						<input type="text" class="admin-input" v-model="form.discount_percentage">
					</div>
					<div class="col-sm-4">
						<label class="admin-text" for="prod-search">Precio Descontado</label>
						<br>
						<input type="text" class="admin-input" placeholder="$" disabled v-model="render_price_discount">
					</div>
				</div>
				<!-- <div class="row">
					<div class="col-sm-7">
						<label class="admin-text" for="prod-search">Tamaño del Mueble</label>
						<br>
						<select class="admin-input" v-model="form.size">
							<option value="" disabled selected>Tamaño del mueble</option>
							<option v-for="size in sizes" :value="size.id">{{ size.name }}</option>
						</select>
					</div>
				</div> -->
				<div class="row">
					<div class="col-sm-7">
						<label class="admin-text" for="prod-search">Existencias</label>
						<br>
						<input type="text" class="admin-input" v-model="form.stock">
					</div>
				</div>
				<div class="row">
					<div class="col-sm-3">
						<div class="img-dimensions vertical-center">
							<span v-if="!render_preview">200 x 200 px</span>
							<img v-if="render_preview" :src="render_preview" width="100%" height="100%" alt="preview of the image."/>
						</div>
					</div>
					<div class="col-sm-2">
						<div class="img-dimensions-clear vertical-center">
							<label class="btn btn-black btn-lg btn-file pull-right">
						    Subir imágen<input type="file" style="display: none;" @change="appendInfoImg">
						</label>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-4">
						<label for="" class="admin-text">Características</label><br>
						<textarea name="" id="" cols="28" rows="8" v-model="form.caracteristics"></textarea>
					</div>
					<div class="col-sm-4">
						<label for="" class="admin-text">Materiales</label><br>
						<textarea name="" id="" cols="28" rows="8" v-model="form.materials"></textarea>
					</div>
					<div class="col-sm-4">
						<label for="" class="admin-text">Conoce más</label><br>
						<textarea name="" id="" cols="28" rows="8" v-model="form.know_more"></textarea>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	.input-group{
		width: 100%;
	}
	.input-group button{
		padding: 5px 12px;
	}
	.custom-checkbox label{
		font-size: 12px;
		color: black;
		font-family: "Open Sans";
	}
</style>

<script>
import { api_base } from '../../store/api';

// ------ FORM ------

var form = {
	name: '',
	sku: '',
	is_for_home: false,
	images: [],
	info_img: {},
	category_id: '',
	subcategory_id: '',
	original_price: '',
	discount_percentage: '',
	price_with_discount: '',
	color: '',
	color2: '',
	caracteristics: '',
	materials: '',
	know_more: ''
};

export default {
	// ------ PROPS ------

	props: ['form'],

	// ------ DATA ------

	data() {
		return {
			// form: form,
			subcategories_list: [],
			preview: {},
			sizes: [
				{ id: 'S', name: 'Small' },
				{ id: 'M', name: 'Medium' },
				{ id: 'L', name: 'Large' }
			]
		};
	},

	// ------- VUEX -------

	vuex: {
		getters: {
			categories: state => state.categories
		}
	},

	// ------ RENDER ------

	computed: {
		render_images() {
			if (this.form.images) {
				return this.form.images;
			}

			return [];
		},

		render_categories() {
			return this.categories;
		},

		render_price_discount() {
			let price_with_discount = null;

			let original_price = this.form.original_price;
			let discount = this.form.original_price * (this.form.discount_percentage / 100);
			price_with_discount = original_price - discount;

			return price_with_discount.toFixed(2);
		},

		render_preview() {
			if (this.form.info_img) {
				return api_base + '/images/' + this.form.info_img;
			}

			return null;
		}
	},

	// ------ METHODS ------

	methods: {
		handleDrop(old_item, new_item) {
			let tmp = this.form.images[old_item.id];
			this.form.images.$set(old_item.id, this.form.images[new_item.id]);
			this.form.images.$set(new_item.id, tmp);
		},

		handleRemove(item, index) {
			this.form.images.splice(index, 1);
		},

		appendImg(e) {
			// Add the product images.
			let file = e.target.files[0];
			file.file_name = file.name;
			this.form.images.push(e.target.files[0]);
		},

		appendInfoImg(e) {
			var component = this;
			// To read and display files.
			let reader = new FileReader();

			this.form.info_img = e.target.files[0];
			
			// When the reader ends from load the image.
			reader.onload = function (file) {
				return function (e) {
					// Get the preview of the image.
					component.preview = e.target;
				};
			}(this.form.info_img);

			// Convert the file in a url base64.
			reader.readAsDataURL(this.form.info_img);
		},

		subcategories() {
			this.form.subcategory_id = null;

			for (var i = 0; i < this.categories.length; i++) {
				if (this.form.category_id == this.categories[i].id) {
					this.subcategories_list = this.categories[i].childrens;
				}
			}
		},

		setSubcategory () {
			
		}
	},

	ready () {
		this.setSubcategory();
	}
}
</script>

<style scoped>
	.col-sm-2{
		padding: 0;
		margin-right: 15px;
	}
	i{
		color: #d8d8d8;
		font-size: 20px;
		padding: 5px;
	}
	@media (max-width: 768px){
		.col-sm-2{
			padding-left: 15px;
		}
	}
</style>


// WEBPACK FOOTER //
// Admin-product-general-edit.vue?6faea9f4